import { render, staticRenderFns } from "./IngestorPage.vue?vue&type=template&id=6d24e5d0"
import script from "./IngestorPage.vue?vue&type=script&lang=js"
export * from "./IngestorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports